<template>
  <div class="bookmarks">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <router-link
      class="help-link help-link_pcr"
      :to="{ path: '/help/19'}"
      target="_blank">
      Подробнее об избранном в разделе Помощь
    </router-link>

    <div class="page-container_pcr">

      <div class="no-results" v-if="noResultsVisible">
        На данный момент Вы ничего не поместили в избранное.
        <div class="depo-msg_dmg dmg_btn dmg_themable"
          @click="$router.push({ path: '/objects/search' })">
          <div class="dmg_star"></div>
          <div class="dmg_text">Здесь Вы можете собрать персональную коллекцию
            понравившихся объектов. Добавить объект в избранное можно во время
            просмотра результатов поиска.</div>
        </div>
      </div>

      <object-teaser
        v-for="el in objects"
        :key="'object-short-' + el.ObjectId"
        :dataSource="el"/>

    </div>

    <page-footer/>
  </div>
</template>

<script>
import axios from 'axios';
import Misc from '../../mixins/Misc';
import ObjectTeaser from '../ObjectTeaser';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';

export default {

  mixins: [Misc],

  components: { PageHeader, PageFooter, NavInner, ObjectTeaser },

  data() {
    return {
      objects: [],
      noResultsVisible: false,
    };
  },

  created() {
    this.$store.dispatch('types/fetchTypes');
    this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {

    fetchData() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId) {
        axios.get(`bookmarks/${userId}`).then((response) => {
          this.objects = response.data;
          this.noResultsVisible = this.objects.length === 0;
        });
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.objects-search {
  margin: 20px 0;
}
.no-results {
  text-align: center;
  font-size: 16px;
  margin-top: 90px;
  @media (max-width: 1000px) {
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserBookmarks.vue